export const Emblem = ({ emblem }) => (
  <img
    style={{ height: '20px', width: 'auto', margin: '0 10px' }}
    src={emblem?.url || '/img/org/org_badge.svg'}
    alt=""
  />
);
